import ApiCore from './core'

class BridgeApi extends ApiCore {
  constructor(model, timeout = 30000) {
    super(model, timeout)

    this.axios.interceptors.request.use(config => {
      const store = require('@/store').default

      config.baseURL = process.env.VUE_APP_BRIDGE_API_BASE_URL
      config.headers = {
        ...config.headers,
        Authorization: `Bearer ${store.state.auth.token}`
      }

      config.query = {
        ...config.query,
        userRef: store.getters['app/getApp']?.user.userRef
      }

      config.data = JSON.stringify(config.data)

      return config
    })
  }
}

export default BridgeApi
